import type { ExtendedConstraints, CapabilityConfig } from '../../../types';
import * as AppletSpec from '../applet/applet';

export type Applet = AppletSpec.Applet;

export const id = 'page-applet';

export enum Events {}
export enum Actions {
  Open = 'page-applet:open',
  Close = 'page-applet:close',
}

export type Config = AppletSpec.Config & {
  type: typeof id;
};

export type QueryParamData = unknown;
export type OpenPayload = {
  configName?: string;
  queryParamData?: QueryParamData;
};
export type ClosePayload = AppletSpec.AppletPayload;

export type Constraints = ExtendedConstraints<{
  events: Events;
  actions: Actions;
  config: Config;

  actionPayloadTuple:
    | [Actions.Open]
    | [Actions.Open, OpenPayload]
    | [Actions.Close]
    | [Actions.Close, ClosePayload];
}>;

export function isValidConfig(config: CapabilityConfig): boolean {
  if (!AppletSpec.isValidConfig(config)) {
    return false;
  }

  if (config.type !== id) {
    return false;
  }

  return true;
}
